import React, { useState, useEffect } from 'react';
import { X, RefreshCw } from 'lucide-react';
import { api } from '../../lib/api';

const SYNC_LABEL = { success: 'Sincronizado', error: 'Error', pending: 'Pendiente', not_applicable: '—' };
const SYNC_COLOR = { success: 'text-green-400', error: 'text-red-400', pending: 'text-gray-500', not_applicable: 'text-gray-600' };

export const PopupLeadsModal = ({ campaign, onClose }) => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/api/popups/${campaign.campaign_id}/leads`)
      .then(r => setLeads(r.data.leads || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [campaign.campaign_id]);

  return (
    <div
      data-testid="popup-leads-modal"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="bg-gray-900 border border-gray-700 rounded-2xl p-6 w-full max-w-3xl max-h-[80vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-4">
          <div>
            <h3 className="text-white font-semibold text-lg">Leads — {campaign.name}</h3>
            <p className="text-gray-500 text-xs mt-1">{leads.length} lead(s) capturado(s)</p>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-white" data-testid="leads-modal-close-btn">
            <X size={18} />
          </button>
        </div>

        {loading ? (
          <div className="flex items-center gap-2 text-gray-400 text-sm py-8 justify-center">
            <RefreshCw size={14} className="animate-spin" /> Cargando…
          </div>
        ) : leads.length === 0 ? (
          <p className="text-gray-500 text-sm text-center py-8">Todavía no se han capturado leads en este popup.</p>
        ) : (
          <table className="w-full text-sm" data-testid="popup-leads-table">
            <thead>
              <tr className="text-gray-500 text-xs border-b border-gray-800">
                <th className="text-left py-2 pr-3">Email</th>
                <th className="text-left py-2 pr-3">Nombre</th>
                <th className="text-left py-2 pr-3">Teléfono</th>
                <th className="text-left py-2 pr-3">Fecha</th>
                <th className="text-left py-2 pr-3">Sync</th>
              </tr>
            </thead>
            <tbody>
              {leads.map(l => (
                <tr key={l.lead_id} className="border-b border-gray-800/60" data-testid={`lead-row-${l.lead_id}`}>
                  <td className="py-2 pr-3 text-gray-200">{l.fields?.email}</td>
                  <td className="py-2 pr-3 text-gray-400">{[l.fields?.name, l.fields?.last_name].filter(Boolean).join(' ') || '—'}</td>
                  <td className="py-2 pr-3 text-gray-400">{l.fields?.phone || '—'}</td>
                  <td className="py-2 pr-3 text-gray-500">{l.submitted_at ? new Date(l.submitted_at).toLocaleString('es-ES') : '—'}</td>
                  <td className={`py-2 pr-3 ${SYNC_COLOR[l.sync?.status] || 'text-gray-500'}`}>
                    {SYNC_LABEL[l.sync?.status] || l.sync?.status || '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
